import api from './api.js';

/**
 * Password management service for non-auth users
 */
class Passwords {

  /**
     * Constructor
     */
  constructor() {

    // Set up URLs
    this.url_send_password_reset = '/passwords/request-reset';
    this.url_password_reset = '/passwords/reset';
  }

  /**
     * Request a password reset email
     * @param {*} data 
     * @return {Promise}
     */
  request(data) {
    return api.post(this.url_send_password_reset, data);
  }

  /**
     * Submit a request to reset a password (with reset token and new password)
     * @param {*} data 
     * @return {Promise}
     */
  reset(data) {
    return api.post(this.url_password_reset, data);
  }
}

export default new Passwords;